// client/src/components/pages/OperationOverview/MatchingNote.tsx (ST-00218 P3)
//
// The small note an Operations Overview view shows once when a route set to "Truck + time"
// shows delivery-number figures instead (LOAD_MATCHING off / shadow, or the load-match ledger
// not ready for the period): the server's note, and its reason as a second, quieter part.
// Tint classes follow the theme's tint system (bg-<hue>-50 + text-<hue>-800 + border-<hue>-300
// works in light and dark, ST-00130).
import { FaInfoCircle } from 'react-icons/fa';
import type { FallbackNote } from '../../../types/clientPages/operationOverview';

export interface MatchingNoteProps {
  note: FallbackNote | null | undefined;
  className?: string;
}

const MatchingNote = ({ note, className = '' }: MatchingNoteProps) => {
  if (!note) return null;
  return (
    <p
      role="note"
      title={note.detail || undefined}
      className={`flex items-start gap-2 rounded-lg border border-amber-300 bg-amber-50 px-3 py-2 text-xs text-amber-800 ${className}`}
    >
      <FaInfoCircle className="mt-0.5 h-3.5 w-3.5 flex-shrink-0" aria-hidden="true" />
      <span className="min-w-0">
        <span className="font-semibold">{note.note}</span>
        {note.detail && <span className="font-normal"> · {note.detail}</span>}
      </span>
    </p>
  );
};

export default MatchingNote;
